import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Modal } from 'synfrastructure';
import { fromJS } from 'immutable';
import numeral from 'numeral';
import moment from 'moment';

import Loading from '../../../common/components/Loading';
import VideoUploader from '../../../common/components/VideoUploader';
import VideoPlayer from '../../../common/video/VideoPlayer';
import Icon from '../../../common/icons/Icon';
import SwingSubmittalPurchaseModal from './SwingSubmittalPurchaseModal';
import { getSwingSubmittals, getSwingSubmittalTypes, purchaseSwingSubmittal, uploadVideo } from './redux/actions';
import { selectSwingSubmittals, selectSwingSubmittalTypes } from './redux/selectors';
import { reportTrainingPurchase, sendIntercomEvent } from '../../../common/events';

class SwingSubmittals extends Component {
  state = {
    modalVisible: false,
    uploadAgain: {},
  };

  componentDidMount() {
    const { dispatch, submittals, types } = this.props;

    // Call to window.scrollTo required after submittals are loaded.
    if (!submittals.loaded && !submittals.loading) {
      dispatch(getSwingSubmittals()).then(() => window.scrollTo(0, 0));
    }

    if (!types.loaded && !types.loading) {
      dispatch(getSwingSubmittalTypes());
    }

    sendIntercomEvent('viewed_swing_submittals');
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.addSwingToSubmittal.get('loaded') && nextProps.addSwingToSubmittal.get('loaded')) {
      const submittalId = nextProps.addSwingToSubmittal.getIn(['data', 'id']);

      this.setState(state => {
        const uploadAgain = state.uploadAgain;

        if (uploadAgain[submittalId]) {
          delete uploadAgain[submittalId];
        }

        return { uploadAgain };
      });
    }
  }

  handleToggleModal = () => {
    const { dispatch } = this.props;
    dispatch(getSwingSubmittalTypes())

    !this.state.modalVisible && sendIntercomEvent('viewed_swing_submittal_purchase_modal');

    this.setState(state => {
      return {
        modalVisible: !state.modalVisible,
      };
    });
  };

  handleSubmit = values => {
    const { dispatch, types } = this.props;
    const submitValues = {};

    if (values.type === 'all') {
      submitValues.types = [];

      types.data.forEach(type => {
        if (type.id !== 'all') {
          submitValues.types.push(type.id);
        }
      });
    } else {
      submitValues.types = [values.type];
    }

    return dispatch(purchaseSwingSubmittal(submitValues)).then(() => {
      // IDs are integers except "all", so cast both to string
      const type = types.data.find(t => t.id.toString() === values.type.toString());

      reportTrainingPurchase({
        gaEventCategory: 'Swing Submittals',
        gaEventLabel: type.short_name,
        intercomEventName: 'purchased_swing',
        intercomEventData: { swingType: type.short_name },
      });
    });
  };

  onVideoUpload = (submittalId, typeName) => file => {
    const { dispatch } = this.props;

    return dispatch(uploadVideo(submittalId, file[0])).then(() => {
      sendIntercomEvent('upload_swing', { swingType: typeName });
    });
  };

  onToggleUploadAgain = submittalId => () => {
    this.setState(state => {
      const uploadAgain = state.uploadAgain;

      uploadAgain[submittalId] = !uploadAgain[submittalId];

      return { uploadAgain };
    });
  };

  renderHero = () => {
    return (
      <div className="hero__wrapper swing__hero__wrapper">
        <div className="container">
          <div className="swing__back">
            <Link to="/subscription/coaching">
              <span className="button__back-button">
                <Icon icon="BackArrow" />
                Back to Additional Coaching
              </span>
            </Link>
          </div>
          <div className="gs__hero">
            <h1>Swing Submittals</h1>
            <h3>
              Send Bryan Hepler a video of your full swing, short game or
              putting motions and receive a full analysis and in-depth video
              reply with recommendations to improve.
              <span className="text--important">
                &nbsp;Each submittal video must be less than 10 seconds.
              </span>
            </h3>
          </div>
        </div>
      </div>
    );
  };

  renderSubmittal(submittal) {
    const { uploadingSwingSubmittalProgress } = this.props;
    const { uploadAgain } = this.state;

    if (submittal.responded_by) {
      return (
        <div className="reviewed-submittal">
          <div className="reviewed-video">
            <VideoPlayer
              title={submittal.type.short_name}
              video={fromJS(submittal.response)}
              sendToIntercom
              intercomEventName={'watched_review'}
            />
          </div>
          <div className="submittal--details">
            <div className="date">
              <div className="icon__wrapper">
                <Icon icon="Check" />
              </div>
              Reviewed on {moment(submittal.updated_at).format('M/D/YYYY')}
            </div>
            <div className="bot">
              Made improvements? <a onClick={this.handleToggleModal}>Submit your swing again!</a>
            </div>
          </div>
        </div>
      );
    } else if (submittal.swing_file_id && !uploadAgain[submittal.id]) {
      return (
        <div className="post-submittal">
          <div className="post-submittal--notice">
            <div className="post-submittal--notice__container">
              <p>Your swing has been uploaded. Someone at Tathata will review it very soon!</p>
              <a className="button button--icon" href={submittal.swing} download>
                <Icon icon="Download" />Download Your Video
              </a>
            </div>
          </div>
          <div className="submittal--details">
            <div className="date">
              <div className="icon__wrapper">
                <Icon icon="Send" />
              </div>
              Uploaded on {moment(submittal.updated_at).format('M/D/YYYY')}
            </div>
            <div className="bot">
              Need to replace the video? <a onClick={this.onToggleUploadAgain(submittal.id)}>Upload Again!</a>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="video-uploader">
        <VideoUploader
          onVideoUpload={this.onVideoUpload(submittal.id, submittal.type.short_name)}
          uploading={!!uploadingSwingSubmittalProgress[submittal.id]}
          uploadProgress={uploadingSwingSubmittalProgress[submittal.id]}
        />
        {uploadAgain[submittal.id] && (
          <div className="video-cancel" onClick={this.onToggleUploadAgain(submittal.id)}>
            Cancel
          </div>
        )}
      </div>
    );
  }

  render() {
    const { submittals, types } = this.props;
    const { modalVisible } = this.state;

    if (!types.loaded || !submittals.loaded) {
      return <Loading />;
    }

    console.log('i got props', this.props);

    return (
      <div className="swing__wrapper">
        {modalVisible && (
          <Modal
            isVisible
            onClose={this.handleToggleModal}
            closeButton={
              <button>
                <Icon icon="Close" />
              </button>
            }
          >
            <SwingSubmittalPurchaseModal onCancel={this.handleToggleModal} onSubmit={this.handleSubmit} />
          </Modal>
        )}
        {this.renderHero()}

        <div className="swing--info__wrapper">
          <div className="swing--info">
            <div className="swing--info__img">
              <img
                src="https://d27vybgvtr1dba.cloudfront.net/swing-submittals/ss-hero-new.jpg"
                alt="Swing Submittals"
              />
            </div>
            <div className="swing--info__details-container">
              <div className="swing--info__details">
                <h2>Swing Submittals</h2>
                <div className="bullets">
                  {types.data.map((type, index) => (
                    <div key={index}>
                      <span className="bull">&bull;</span>
                      {`${type.long_name} | ${type.price === 0 ? 'FREE' : numeral(type.price / 100).format('$0,0.00')}`}
                    </div>
                  ))}
                </div>
              </div>
              <button className="button button--icon" onClick={this.handleToggleModal}>
                <Icon icon="Plus" />
                <span>Add a Swing</span>
              </button>
            </div>
          </div>
        </div>
        {!!submittals.data.length && (
          <div className="swing--submittals__wrapper">
            <div className="swing-container">
              <h3>Your Submittals</h3>
              <div className="submittals">
                {submittals.data.map((submittal, index) => (
                  <div className="submittal--container" key={index}>
                    <div className="submittal-zone">
                      <h4>{submittal.type.short_name}</h4>
                      <div className="submittal">{this.renderSubmittal(submittal)}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    addSwingToSubmittal: state.subscription.swingSubmittals.addSwingToSubmittal,
    submittals: selectSwingSubmittals(state),
    types: selectSwingSubmittalTypes(state),
    uploadingSwingSubmittalProgress: state.subscription.swingSubmittals.uploadingSwingSubmittalProgress,
  };
};

export default connect(mapStateToProps)(SwingSubmittals);



// WEBPACK FOOTER //
// ./src/subscription/coaching/swing-submittals/SwingSubmittals.js